import React from 'react'

const DetailsComponent = ({
    label,
    inputDetails,
  }) => {
  return (
     <div className="mx-2 mt-4 lg:flex">
        <h2 className="w-5/6  block font-bold ">{label}</h2>
        <div 
        className=" lg:w-64 md:32  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0"
        >
        {inputDetails}
        </div>
    </div>
  )
}

export default DetailsComponent